module.exports = __webpack_public_path__ + "static/media/banner-resgate-de-dominio-gratuito.3bcf2547.png";